import React from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Form, Input, Button, notification, Tooltip } from 'antd'

import { mapStateToProps, mapDispatchToProps, connect } from '../../reducers/Dispatchers'
import { getEnvironment, request } from '../../utils'
import { HttpMethods } from '../../utils/apiHelper'
import { Environments } from '../../config/environments'
import { ColorsPalette } from '../../config/colors'

const FormItem = Form.Item

class NormalPasswordResetAskForm extends React.Component {
  state = {
    loading: false
  }

  handleSubmit = (e) => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const email = values.email.trim().toLowerCase()

        this.setState({ loading: true })
        request('/user/forgot-password', HttpMethods.POST, { email }, null, { catchError: false }).then((json) => {
          this.setState({ loading: false })

          if (json.status === 'error') {
            notification.error({ message: this.props.t('This email address does not exist !'), placement: 'bottomRight' })
            return
          }

          notification.success({ message: this.props.t('We sent you an email containing your password reset link.'), placement: 'bottomRight' })
          this.props.onBack()
        })
      }
    })
  }

  render () {
    const { getFieldDecorator } = this.props.form

    return (
      <>
        <Form onSubmit={this.handleSubmit}>
          {this.props.t('What is your email address ? We will send you an email containing a link to reset your password.')}
          <FormItem style={{ marginBottom: '10px' }}>
            {getFieldDecorator('email')(
              <Input prefix={<FontAwesomeIcon icon='at' />} placeholder={this.props.t('Email address')} />
            )}
          </FormItem>
          <div className='flex-row'>
            <Tooltip placement='top' title={this.props.t('Back')}>
              <Button type='default' onClick={this.props.onBack}>
                <FontAwesomeIcon icon='arrow-left' />
              </Button>
            </Tooltip>
            <div className='h-spacing' />
            <Button type='primary' htmlType='submit' className='full-width' loading={this.state.loading}>
              <FontAwesomeIcon icon='check' />&nbsp;{this.props.t('Confirm my email address')}
            </Button>
          </div>
        </Form>
        {getEnvironment() !== Environments.PROD && (
          <div className='mt-8 modal-inner-container warning'>
            <div className='flex-row ai-bl'>
              <FontAwesomeIcon
                color={ColorsPalette.WARNING_FONT}
                icon='exclamation-circle'
              />
              <div className='flex-col ai-bl'>
                <span className='pdl-4' style={{ fontSize: '14px' }}>{this.props.t('info_staging.forgotten_password')}</span>
                <a href='https://app.interneo.pro'>
                  <span className='pdl-4' style={{ fontSize: '14px' }}>{this.props.t('info_staging.link_to_prod')}</span>
                </a>
              </div>
            </div>
          </div>
        )}
      </>
    )
  }
}

const PasswordResetAskForm = Form.create()(NormalPasswordResetAskForm)
export default connect(mapStateToProps, mapDispatchToProps)(PasswordResetAskForm)
